import React from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
// import { TextInputField } from 'evergreen-ui';

import { useFormatParseNumeral } from '../useFormatParseNumeral';

function NumericalInputField(props) {
  const [value, setValue] = useFormatParseNumeral(props.value, {
    maxFixed: 5,
    whole: false
  });

  function handleChange(e) {
    props.onChange(setValue(e.target.value));
  }

  return (
<InputGroup className="mb-3">
        <InputGroup.Text>{props.label}</InputGroup.Text>
        <Form.Control
          placeholder={props.placeholder}
          value={value}
          onChange={handleChange}
        />
</InputGroup>
  );
}

export default NumericalInputField;


